import { createSlice } from "@reduxjs/toolkit";

const pageTitleSlice = createSlice({
    name: 'pageTitle',
    initialState: { pageTitle: '' },
    reducers: {
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload;
            document.title = action.payload;
        }
    }
});

export const { setPageTitle } = pageTitleSlice.actions;
export default pageTitleSlice.reducer;